import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import { CookiesProvider } from "react-cookie";
import baseURL from "./api.js";

import { Provider as PortalProvider } from "./context/portal.context.js";
import { Provider as AuthProvider } from "./context/auth.context.js";

axios.defaults.headers.post["Origin"] = baseURL();
axios.defaults.baseURL = baseURL();

ReactDOM.render(
  <React.StrictMode>
    {/* <Router basename="/customerportal"> */}
    <Router basename="/customerportal">
      <CookiesProvider>
        <PortalProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </PortalProvider>
      </CookiesProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
